import React from "react";


function Footer() {
  return (
    <div>
      <footer className="blue lighten-4 page-footer">
          <div className="blue lighten-2 footer-copyright">
            <div className="container white-text text-lighten-2 ">
            <center>
            <a className="white-text text-lighten-2 middle" target="blank" href="https://github.com/jitencodes">Made with ♥ by <b>jitendra</b></a>
            </center>
            </div>
          </div>
        </footer>
    </div>
  );
}

export default Footer;
